/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { bool } from 'prop-types';

const useStyles = (isDadJokeGPT) =>
    makeStyles({
        note: {
            fontFamily: 'Lato, sans-serif !important',
            color: `${isDadJokeGPT ? '#434343' : '#262626'}`,
            textAlign: 'center',
            fontWeight: 400,
            fontSize: '12px !important',
            lineHeight: '20px',
            marginTop: `${!isDadJokeGPT ? '12px' : '0'} !important`,
            '& > a': {
                fontSize: '12px !important',
                fontFamily: 'Lato, sans-serif !important',
                color: `${isDadJokeGPT ? '#434343' : '#262626'}!important`,
            },
        },
    });

const Disclaimer = ({ isDadJokeGPT }) => {
    const classesLayout = useStyles(isDadJokeGPT);
    const classes = classesLayout(isDadJokeGPT);

    return (
        <p className={classes.note}>
            By continuing, you understand and agree that the contents of this feature may be recorded by us or by third
            parties working with us, and used as described in our{' '}
            <Link to="/About-Us-Privacy-Policy" target="_blank" rel="noopener noreferrer">
                Privacy Notice
            </Link>
            . If you do not agree, please do not use this feature.
        </p>
    );
};

Disclaimer.defaultProps = {
    isDadJokeGPT: false,
};

Disclaimer.propTypes = {
    isDadJokeGPT: bool,
};

export default Disclaimer;
